var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownArow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.43557 5.35494L0.838394 1.24388C0.414074 0.758941 0.758457 0 1.40283 0H8.59717C9.24154 0 9.58593 0.75894 9.16161 1.24388L5.56443 5.35493C5.26562 5.69643 4.73438 5.69643 4.43557 5.35494Z",
    fill: "#6B7085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArow);
export default __webpack_public_path__ + "static/media/dropdown-arow.732127db54172bd46c9d0e020be61598.svg";
export { ForwardRef as ReactComponent };